// extracted by mini-css-extract-plugin
export default {"schedule-container":"schedule_schedule-container__vl4Pt","tabs":"schedule_tabs__traLJ","destinations":"schedule_destinations__WguPV","active":"schedule_active__wqcOT"};